const LOGIN_URL = 'https://forms.conversionhive.au/auth/login';

export default function LoginPage() {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', height: '100vh', gap: '24px',
      fontFamily: 'system-ui, sans-serif', background: '#f5f5f5',
    }}>
      <div style={{
        background: '#fff', padding: '48px', borderRadius: '12px',
        boxShadow: '0 2px 16px rgba(0,0,0,0.1)', textAlign: 'center',
        minWidth: '320px',
      }}>
        <h1 style={{ margin: '0 0 8px', fontSize: '22px', fontWeight: 700 }}>Form Handler</h1>
        <p style={{ margin: '0 0 32px', color: '#666', fontSize: '14px' }}>Sign in to access the dashboard</p>
        <a
          href={LOGIN_URL}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: '10px',
            padding: '12px 24px', borderRadius: '6px', fontSize: '15px',
            fontWeight: 500, textDecoration: 'none', color: '#333',
            border: '1px solid #ddd', background: '#fff', cursor: 'pointer',
          }}
        >
          <svg width="18" height="18" viewBox="0 0 18 18">
            <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"/>
            <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"/>
            <path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"/>
            <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"/>
          </svg>
          Sign in with Google
        </a>
      </div>
    </div>
  );
}
